import React from 'react';
// import PropTypes from 'prop-types';
import { withRouter, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
// import loadable from 'loadable-components';
// import { push } from 'react-router-redux';

// Components
import SiteHeader from 'components/SiteHeader/SiteHeader';
import Directory from 'components/Directory/Directory';
import Pathways from 'components/Pathways/Pathways';
import Home from 'components/Home/Home';
import Report from 'components/Report/Report';
import Details from 'components/Details/Details';
import AddOrg from 'components/AddOrg/AddOrg';
import Footer from 'components/Footer/Footer';
import ErrorBoundary from 'components/_shared/ErrorBoundary/ErrorBoundary';

// SVGs
// Constants
//Redux Actions
import { fetchProviders } from 'store/modules/db/providers/providersReducer';
import { fetchLocations } from 'store/modules/db/locations/locationsReducer';

// Styles
import './App.css';


// TODO: need loading page
// const Loading = () => <div className="loading"></div>; // loading component
// dynamic loading <App />, <About /> and <PageNotFound /> components
// Loadable is higher order components. it takes loader which dynamic import() of desired component
// and loading which component shows during successfully resolving dyanmic import()
// const Directory = loadable(
//   () => import("components/Directory/Directory"), {
//     loadingComponent: Loading
//   });
// const Pathways = loadable(
//   () => import("components/Pathways/Pathways"), {
//     loadingComponent: Loading
//   });
// const Home = loadable(
//   () => import("components/Home/Home"), {
//     loadingComponent: Loading
//   });
// const Report = loadable(
//   () => import("components/Report/Report"), {
//     loadingComponent: Loading
//   });
// const AddMe = loadable(
//   () => import("components/AddMe/AddMe"), {
//     loadingComponent: Loading
//   });

const PageNotFound = () => {
  return (
    <div className="notFound">
      <h1>404</h1>
      <h2>Page Not Found</h2>
    </div>
  )
}


// const mapStateToProps = state => ({
//   artworxProviders: state.db.providers.providers,
//   locations: state.db.locations.locations,
// });
//
const defaultState = {
  errors: null
};

export class App extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {};
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //
  // constructor(props) {
  //   super(props);
  // }

  // Variables
  // ------------------------------------------------------------------------ //
  state = defaultState;

  // Lifecycle methods
  // ------------------------------------------------------------------------ //
  // componentDidMount() {
  // }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  // Event handlers
  // ------------------------------------------------------------------------ //

  // Class methods
  // ------------------------------------------------------------------------ //
  getArtworxProviders = async () => {
    await this.props.dispatch(fetchProviders());
  }

  getLocationData = async () => {
    await this.props.dispatch(fetchLocations());
  }

  // Render methods
  // ------------------------------------------------------------------------ //
  render() {
    return (
      <div className="artworx-app">
        <ErrorBoundary>
          <SiteHeader
            path={this.props.location.pathname} />
        </ErrorBoundary>
        <ErrorBoundary>
          <main className={`main`}>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/directory"
                component={props => <Directory {...props} getProviders={this.getArtworxProviders} getLocations={this.getLocationData}/>} />
              <Route exact path="/pathways" component={Pathways} />
              <Route exact path="/report" component={Report} />
              <Route exact path="/add-org" component={AddOrg} />
              <Route exact path="/details/:org"
                component={props => <Details {...props} getProviders={this.getArtworxProviders}/>} />
              <Route component={PageNotFound} />
            </Switch>
          </main>
        </ErrorBoundary>
        <ErrorBoundary>
          <Footer />
        </ErrorBoundary>
      </div>
    );
  }
}

// export default withRouter(App);
// export default withRouter(connect(mapStateToProps)(App));
export default withRouter(connect(null)(App));



// WEBPACK FOOTER //
// ./src/components/App.js